import {SpaceProto} from "../space-proto";
import {NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import MainMenu_CRM from "../../../../layout/menu/sections/crm/crm";

export class SpaceCrm extends SpaceProto{

    constructor() {
        super(NavigationSectionType.CRM)

        this.title      = "CRM"
        this.svgIcon    = "isvg-crm-space"
    }

    get enabled(): boolean {
        return gd.modules.crm.enabled
    }

    get navigationStructureConfig() {
        return {
            id              : this.id,
            type            : NavigationSectionType.CRM,
            icon            : "i5-crm-account",
            name            : "CRM",
            hint            : 'CRM',
            menuComponent   : MainMenu_CRM,
            renderComponent : Navigation_ButtonGeneric,
            onClick         : navigationStructureOnClick,
            position        : getNavigationPosition(NavigationSectionType.CRM),
        }
    }

}